import "./Pricing.module.css";
import Header from "@/reusable_sections/Header";
import PricingHero from "./sections/PricingHero";
import SimpleAndClearPricing from "./sections/SimpleAndClearPricing";
import GlobalPartnersMap from "./sections/GlobalPartnersMap";
import PartnerProgramCta from "./sections/PartnerProgramCta";
import Footer from "@/reusable_sections/Footer";
export default function PricingPage() {
  return <div>
      <Header />
      <PricingHero />
      <SimpleAndClearPricing />
      <GlobalPartnersMap />
      <PartnerProgramCta />
      <Footer />
    </div>;
}